import { useTranslation } from 'react-i18next'

import clsx from 'clsx'
import { observer } from 'mobx-react-lite'

import { useHeaderMeta } from 'pages/tours/search-result-page/model/hooks/useHeaderMeta.ts'

import { useFlights } from 'entities/tour/hooks'
import { selectionStore } from 'entities/tour/models'

import { getRawColor } from 'shared/lib/getRawColor.ts'
import { HeaderGoBack } from 'shared/ui/header-go-back'

import { FlightList, TourSummaryCard } from './components'
import s from './styles.module.scss'

const FlightSelectionPage = observer(() => {
  const { t } = useTranslation()
  const { title, subtitle } = useHeaderMeta()
  const roomDetail = selectionStore.getSelectedRoom()
  const { flights, rawFlights, isLoading, error } = useFlights(
    roomDetail?.id,
    roomDetail?.operator_key,
  )

  return (
    <div className={clsx(s.container, 'container')}>
      <HeaderGoBack
        variant={'white'}
        title={t('tours_block.choose_convenient_flight')}
        arrowColor={getRawColor('--black')}
        buttonWhite
      />

      <TourSummaryCard
        title={title}
        subtitle={subtitle}
      />

      <FlightList
        flights={flights}
        rawFlights={rawFlights}
        isLoading={isLoading}
        error={error}
      />
    </div>
  )
})

export default FlightSelectionPage
